module.exports = __webpack_public_path__ + "static/media/lock.58949742.svg";